export default __webpack_public_path__ + "img/logo-white.c4855cc7.svg";